<template>
  <f7-page>
    <pre>signin</pre>
    <!-- <f7-swiper pagination>
      <f7-swiper-slide>
        <div class="welcome-slide">
          <div class="welcome-image">
            <img src="../../assets/images/welcome-desk.jpg">
          </div>
          <h1>{{ t('welcome.s1.title') }}</h1>
          <p class="welcome-text">
            {{ t('welcome.s1.text') }}
          </p>
          <f7-button
            raised
            @click="next">
            {{ t('welcome.s1.cta') }}
          </f7-button>
        </div>
      </f7-swiper-slide>
      <f7-swiper-slide>
        <div class="welcome-slide">
          <div class="welcome-image">
            <img src="../../assets/images/welcome-localisation.jpg">
          </div>
          <h1>{{ t('welcome.s2.title') }}</h1>
          <p class="welcome-text">
            {{ t('welcome.s2.text') }}
          </p>
          <f7-button
            raised
            @click="getPosition">
            {{ t('welcome.s2.cta') }}
          </f7-button>
        </div>
      </f7-swiper-slide>
    </f7-swiper> -->
  </f7-page>
</template>

<script>
/* global backgroundGeolocation */
export default {
  name: 'SigninPage',
  methods: {
    next () {
      const swiper = this.$f7.swiper.get('.swiper-container')
      swiper.slideNext()
    },
    getPosition () {
      backgroundGeolocation.start(() => {
        // service started successfully
        // you should adjust your app UI for example change switch element to indicate
        // that service is running
        this.$f7router.navigate('/', { clearPreviousHistory: true })
      }, (error) => {
        // Tracking has not started because of error
        // you should adjust your app UI for example change switch element to indicate
        // that service is not running
        console.log(error)
        if (error.code === 2) this.$f7router.navigate('/location/authorize', { clearPreviousHistory: true })
        else this.$f7router.navigate('/location/enable', { clearPreviousHistory: true })
      })
    }
  }
}
</script>
